(() => {
  const initialize = (root = document) => {
    root.querySelectorAll('.dose-newsletter__form').forEach((form) => {
      if (form.dataset.offerReady) return;
      form.dataset.offerReady = 'true';
      const submit = form.querySelector('button[type="submit"]');
      if (submit) {
        const label = submit.textContent;
        const reset = () => { submit.textContent = label; submit.removeAttribute('aria-busy'); };
        form.addEventListener('submit', () => {
          submit.textContent = submit.dataset.saving;
          submit.setAttribute('aria-busy', 'true');
          window.setTimeout(reset, 15000);
        });
        window.addEventListener('pageshow', reset);
      }
      const copy = form.querySelector('[data-copy-code]');
      if (copy && navigator.clipboard?.writeText) {
        copy.hidden = false;
        copy.addEventListener('click', async () => {
          try {
            await navigator.clipboard.writeText(form.querySelector('[data-offer-code]').textContent.trim());
            copy.textContent = copy.dataset.copied;
          } catch {
            const range = document.createRange();
            range.selectNodeContents(form.querySelector('[data-offer-code]'));
            const selection = window.getSelection();
            selection.removeAllRanges();
            selection.addRange(range);
          }
        });
      }
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
